import { Menu, Fade, MenuItem } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "rsuite";
import { If } from "../../../../../common/components/If";
import { getPathWithParameters, PATH } from "../../../../../router-path";
import { Pricing, PricingStatus } from "../../../pricingListSlice";

export function ContractLinksCell(props: {
	pricing?: Pricing;
}): React.ReactElement {
	const { pricing } = props;
	const [contractMenu, setContractMenu] = useState<null | HTMLElement>(null);
	const open = Boolean(contractMenu);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setContractMenu(event.currentTarget);
	};
	const handleClose = () => {
		setContractMenu(null);
	};
	return (
		<>
			<If
				condition={
					pricing?.parties &&
					pricing?.parties?.length === 1 &&
					pricing?.status === PricingStatus.BOOKED
				}
			>
				<Link
					style={{
						display: "flex",
						justifyContent: "center",
					}}
					to={
						pricing?.parties
							? getPathWithParameters(PATH.CONTRACT_DETAIL, {
									contractId:
										pricing?.parties[0]?.geco_contract_id,
							  })
							: "#"
					}
				>
					{pricing?.parties
						? pricing?.parties[0]?.geco_contract_id
						: null}
				</Link>
			</If>
			<If
				condition={
					pricing?.parties &&
					pricing?.parties?.length === 1 &&
					pricing?.status === PricingStatus.BOOKED_MANUALLY
				}
			>
				<Link
					style={{
						display: "flex",
						justifyContent: "center",
					}}
					to={
						pricing?.parties
							? getPathWithParameters(PATH.CONTRACT_DETAIL, {
									contractId: pricing?.geco_contract_id ?? "",
							  })
							: "#"
					}
				>
					{pricing?.geco_contract_id}
				</Link>
			</If>
			<If condition={pricing?.parties && pricing?.parties?.length > 1}>
				<Button
					id="contract-button"
					aria-controls={open ? "contract-menu" : undefined}
					aria-haspopup="true"
					aria-expanded={open ? "true" : undefined}
					onClick={handleClick}
				>
					Many
				</Button>
				<Menu
					//@ts-ignore
					id="contract-menu"
					MenuListProps={{
						"aria-labelledby": "contract-button",
					}}
					anchorEl={contractMenu}
					open={open}
					onClose={handleClose}
					TransitionComponent={Fade}
				>
					{pricing?.parties &&
						pricing?.parties.map((party) => (
							<MenuItem
								key={party.party_id}
								onClick={handleClose}
							>
								<Link
									to={getPathWithParameters(
										PATH.CONTRACT_DETAIL,
										{
											contractId: party?.geco_contract_id,
										}
									)}
								>
									{party?.party?.name} ({party.percentage}%):{" "}
									{party?.geco_contract_id}
								</Link>
							</MenuItem>
						))}
				</Menu>
			</If>
		</>
	);
}
